import React from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  CardMedia,
  CardContent,
  Chip,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";
import reinforcementImg from "images/itservice/v2/reinforcement.jpg";
import leaseImg from "images/itservice/v2/lease.jpeg";
import chineseImg from "images/itservice/v2/chinese-business.jpg";
import systemDevImg from "images/itservice/v2/ses-dev.jpg";
import systeEngImg from "images/itservice/v2/ses.jpg";
import BgTitle from "components/title/BgTitle";

export default ({ isXs = false }) => {
  const { t } = useTranslation();

  const services = [
    {
      imageSrc: systemDevImg,
      title: t("home_section3_service1_title"),
      content: t("home_section3_service1_desc"),
      url: "/it-service",
      category: "Service",
    },
    {
      imageSrc: systeEngImg,
      title: t("home_section3_service2_title"),
      content: t("home_section3_service2_desc"),
      url: "/business#system-engineering",
      category: "Engineering",
    },
    {
      imageSrc: reinforcementImg,
      title: t("home_section3_service3_title"),
      content: t("home_section3_service3_desc"),
      url: "/business-reinforcement",
      category: "Business",
    },
    {
      imageSrc: leaseImg,
      title: t("home_section3_service5_title"),
      content: t("home_section3_service5_desc"),
      url: "/business#lease-business",
      category: "Lease",
    },
    {
      imageSrc: chineseImg,
      title: t("home_section3_service6_title"),
      content: t("home_section3_service6_desc"),
      url: "/business#chinese-market",
      category: "Market",
    },
  ];

  return (
    <Container
      sx={{
        py: 3,
        px: 2,
      }}
    >
      {/* Header Section */}
      <Box sx={{ mb: 3, px: 1 }}>
        <BgTitle text={t("home_section3_title")} isCenter={true} />
      </Box>

      {/* Services Grid */}
      <Grid container spacing={2}>
        {services.map((service, index) => (
          <Grid item xs={6} key={index}>
            <Card
              component="a"
              href={service.url}
              elevation={0}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                textDecoration: "none",
                borderRadius: 3,
                overflow: "hidden",
                transition: "all 0.2s ease-in-out",
                bgcolor: "#f5f5f5",
                border: "1px solid",
                borderColor: "divider",
                "&:active": {
                  transform: "scale(0.98)",
                  bgcolor: "action.selected",
                },
                "&:hover": {
                  borderColor: "primary.main",
                },
              }}
            >
              <CardMedia
                component="div"
                sx={{
                  height: 130,
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${service.imageSrc})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative",
                }}
              >
                <Chip
                  label={service.category}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 8,
                    left: 8,
                    bgcolor: "rgba(255, 255, 255, 0.9)",
                    fontSize: "0.7rem",
                    height: 20,
                  }}
                />
              </CardMedia>

              <CardContent
                sx={{
                  p: 1.5,
                  "&:last-child": { pb: 1.5 },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    color: "text.primary",
                    lineHeight: 1.3,
                    flex: 1,
                    pr: 1,
                  }}
                >
                  {service.title}
                </Typography>
                <ChevronRightIcon
                  sx={{
                    color: "primary.main",
                    fontSize: "1.25rem",
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
